import React, { useState } from 'react';
import AccountRates from "./AccountRates";
import AccountRateHistory from "./AccountRateHistory";
import RepriceAccount from './RepriceAccount';

export default function AccountInterestDetails() {
    const [refreshToken, setRefreshToken] = useState(0);

    return (
        <section>
            <div className="ui grid">
                <div className="three wide column">
                    <div className="ui cards">
                        <AccountRates refreshToken={refreshToken}/>
                    </div>
                </div>
                <div className="ten wide column">
                    <AccountRateHistory refreshToken={refreshToken}/>
                </div>
                <div className="three wide column">
                    <RepriceAccount onRepriced={() => setRefreshToken((current) => current + 1)} />
                </div>
            </div>
        </section>
    );
}
